import React, { useEffect, useState } from "react";

function useUnsavedChangesWarning(
  message = "Are you sure you want to exit  the assessment?"
) {
  const [toShow, setToShow] = useState(true);
  useEffect(() => {
    window.onbeforeunload = toShow && (() => message);
    return () => {
      window.onbeforeunload = null;
    };
  }, [toShow]);

  const routerPrompt = <prompt when={toShow} message={message} />;
  return [routerPrompt, () => setToShow(false)];
}

export default useUnsavedChangesWarning;
